import { render, staticRenderFns } from "./ManifestBKK.vue?vue&type=template&id=78b765b2&scoped=true&"
import script from "./ManifestBKK.vue?vue&type=script&lang=js&"
export * from "./ManifestBKK.vue?vue&type=script&lang=js&"
import style0 from "./ManifestBKK.vue?vue&type=style&index=0&id=78b765b2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78b765b2",
  null
  
)

export default component.exports